import React from 'react';
import { ElementInViewport } from '../../components/element_in_viewport';
import { FiltersSearchButton } from '../../components/FiltersSearchButton';
import { trackCalculateClick } from './tracking';
import { useTrackIntoView } from './utils/useTrackIntoView';

export const FiltersMortgageButtonsContainer = () => {
  const trackIntoView = useTrackIntoView();

  return (
    <ElementInViewport onChange={trackIntoView}>
      <FiltersSearchButton
        onClick={trackCalculateClick}
        dataMark="FiltersMortgageRightButton"
        text="Рассчитать"
        title="Рассчитать"
        href="#calculator"
      />
    </ElementInViewport>
  );
};
